import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CategoryApiService } from './category-api.service';
import { CategoryEffects } from './category.effects';
import { categoryInitialState, categoryReducer } from './category.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('category', categoryReducer, {
      initialState: categoryInitialState
    }),
    EffectsModule.forFeature([CategoryEffects])
  ],
  providers: [CategoryApiService]
})
export class CategoryStoreModule {}
